import React, { Component } from 'react';
import Parser from 'html-react-parser';
import { ExchangeIcon, TruckIcon, ChevronRightIcon } from './SVGIcons';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {

    const data = this.props?.data || {}
    const vars = data?.vars || {}
    const links = data?.links || {}

    return (
      <div className='mt-[40px] w-full'>
        <div className='container'>
          <div className='text-title text-ptblack uppercase tracking-tight'>{Parser(data?.h1 || data?.pagetitle)}</div>
          <div className='text-base text-ptgray mt-[12px] max-w-[640px] leading-none'>
            {Parser(data?.introtext || '')}
          </div>
          <div className='mt-[40px] flex-col lg:flex-row flex gap-[20px]'>
            <div className='w-full lg:w-auto flex-1 bg-[#F6F7F8] rounded-[14px] min-h-[200px] p-[20px] flex flex-col justify-between items-center'>
              <div className='flex justify-end w-full'>
                <ExchangeIcon width={24} height={24} stroke="#001553" />
              </div>
              <div className='leading-none'>
                <div className='text-cardTitle text-ptblack uppercase'>{Parser(vars?.about_c1_title)}</div>
                <div className='text-ptgray text-base mt-[12px]'>
                  {Parser(vars?.about_c1_text)}
                </div>
              </div>
            </div>
            <div className='w-full lg:w-[355px] flex-none bg-[#F6F7F8] rounded-[14px] min-h-[200px] p-[20px] flex flex-col justify-between items-center'>
              <div className='flex justify-end w-full'>
                <TruckIcon width={24} height={24} stroke="#001553" />
              </div>
              <div className='leading-none'>
                <div className='text-cardTitle text-ptblack uppercase'>{Parser(vars?.about_c2_title)}</div>
                <div className='text-ptgray text-base mt-[12px]'>
                  {Parser(vars?.about_c2_text)}
                </div>
              </div>
            </div>
            <img src={vars?.about_image1} alt='' width={358} height={200} className='w-full lg:w-[358px] h-auto flex-none' />
          </div>
          <div className='mt-[20px] flex gap-[20px] flex-col lg:flex-row'>
            <img src={vars?.about_image2} alt='' width={386} height={184} className='w-full lg:w-[386px] h-auto flex-none' />
            <div style={{ backgroundImage: `url('${vars?.about_с3_bg}')` }} className='w-full lg:w-auto bg-cover bg-center flex-auto min-h-[184px] bg-[#001553] rounded-[14px] flex flex-col lg:flex-row items-center justify-between gap-[19px] p-[20px]'>
              <div className='leading-none'>
                <div className='text-white font-light leading-none text-cardTitle uppercase'>{Parser(vars?.about_c3_title)}</div>
                <div className='mt-[12px] text-base text-white/60'>
                  {Parser(vars?.about_c3_text)}
                </div>
                <a href={links?.sotrudnichestvo} className='cursor-pointer max-w-[343px] bg-white duration-300 ease-in-out hover:bg-[#DBE7F3] px-[22px] h-[48px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-[#001553] mt-[27px]'>
                  <div className='text-base'>О сотрудничестве</div>
                  <ChevronRightIcon width={6} height={12} stroke="currentColor" />
                </a>
              </div>
              <img src={vars?.about_с3_image} alt="123" className='w-full sm:w-[300px] flex-none h-auto' width={300} height={144} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;